import request from "@/utils/request";

// Auth
export function login(data) {
    return request({ url: "/auth/login", method: "post", data });
}
export function logout(data) {
    return request({ url: "/auth/logout", method: "post", data });
}
export function tokens(data) {
    return request({ url: "/auth/token", method: "post", data });
}
export function login_yzm(data) {
    return request({ url: "/auth/captcha", method: "post", data });
}
export function yzm_login(data) {
    return request({ url: "/auth/verify", method: "post", data });
}
export function reg_login(data) {
    return request({ url: "/auth/reg", method: "post", data });
}


// Dashboard
export function home_statistics(data) {
    return request({ url: "/dashboard/stats", method: "get", params: data });
}
export function home_exceptions(data) {
    return request({ url: "/dashboard/exceptions", method: "get", params: data });
}
export function home_bar(data) {
    return request({ url: "/dashboard/bar", method: "get", params: data });
}
export function home_infos(data) {
    return request({ url: "/dashboard/infos", method: "get", params: data });
}
export function home_query_record(data) {
    return request({ url: "/dashboard/records", method: "get", params: data });
}
export function home_get_count(data) {
    return request({ url: "/dashboard/metrics", method: "get", params: data });
}
export function home_news_list(data) {
    return request({ url: "/dashboard/alerts", method: "get", params: data });
}
export function home_delete_info(data) {
    return request({ url: "/dashboard/alert/remove", method: "post", data });
}
export function home_news_info(data) {
    return request({ url: "/dashboard/alert/detail", method: "get", params: data });
}
export function home_news_count(data) {
    return request({ url: "/dashboard/alert/count", method: "get", params: data });
}
export function home_read_all(data) {
    return request({ url: "/dashboard/alert/readall", method: "post", data });
}

// Layout
export function template_query_template(data) {
    return request({ url: "/layout/list", method: "get", params: data });
}
export function template_modify_use(data) {
    return request({ url: "/layout/toggle", method: "post", data });
}
export function template_result_template(data) {
    return request({ url: "/layout/result", method: "get", params: data });
}
export function template_diy_list(data) {
    return request({ url: "/layout/custom/list", method: "get", params: data });
}
export function template_copy_result(data) {
    return request({ url: "/layout/clone", method: "post", data });
}
export function template_diy_copy(data) {
    return request({ url: "/layout/custom/copy", method: "post", data });
}
export function template_diy_save(data) {
    return request({ url: "/layout/custom/save", method: "post", data });
}
export function template_diy_manage(data) {
    return request({ url: "/layout/custom/pages", method: "get", params: data });
}
export function template_diy_del(data) {
    return request({ url: "/layout/custom/remove", method: "post", data });
}
export function template_diy_save_manage(data) {
    return request({ url: "/layout/custom/pages/update", method: "post", data });
}
export function template_diy_del_manage(data) {
    return request({ url: "/layout/custom/pages/delete", method: "post", data });
}
export function template_diy_manage_info(data) {
    return request({ url: "/layout/custom/pages/detail", method: "get", params: data });
}
export function template_diy_set(data) {
    return request({ url: "/layout/custom/pages/default", method: "post", data });
}
export function template_query_content(data) {
    return request({ url: "/layout/content", method: "get", params: data });
}
export function template_modify_query(data) {
    return request({ url: "/layout/update", method: "post", data });
}
export function attr_page(data) {
    return request({ url: "/layout/custom/attrs/pages", method: "get", params: data });
}
export function page_attrs(data) {
    return request({ url: "/layout/custom/attrs/list", method: "get", params: data });
}
export function save_page_attrs(data) {
    return request({ url: "/layout/custom/attrs/save", method: "post", data });
}
export function diy_manage_select(data) {
    return request({ url: "/layout/custom/pages/options", method: "get", params: data });
}

// Items
export function product_list(data) {
    return request({ url: "/items/list", method: "get", params: data });
}
export function product_save(data) {
    return request({ url: "/items/save", method: "post", data });
}
export function product_type_list(data) {
    return request({ url: "/items/category/list", method: "get", params: data });
}
export function product_type_save(data) {
    return request({ url: "/items/category/save", method: "post", data });
}
export function product_type_del(data) {
    return request({ url: "/items/category/remove", method: "post", data });
}
export function product_attribute_list(data) {
    return request({ url: "/items/props/list", method: "get", params: data });
}
export function product_attribute_save(data) {
    return request({ url: "/items/props/save", method: "post", data });
}
export function product_attribute_del(data) {
    return request({ url: "/items/props/remove", method: "post", data });
}
export function product_info(data) {
    return request({ url: "/items/detail", method: "get", params: data });
}
export function product_change_template(data) {
    return request({ url: "/items/template", method: "post", data });
}
export function product_delete(data) {
    return request({ url: "/items/remove", method: "post", data });
}
export function product_samplebook_list(data) {
    return request({ url: "/items/catalog/list", method: "get", params: data });
}
export function product_samplebook_save(data) {
    return request({ url: "/items/catalog/save", method: "post", data });
}
export function product_samplebook_del(data) {
    return request({ url: "/items/catalog/remove", method: "post", data });
}
export function product_reports(data) {
    return request({ url: "/items/report", method: "post", data });
}
export function product_add_attribute(data) {
    return request({ url: "/items/attr/attach", method: "post", data });
}
export function product_attribute_content_list(data) {
    return request({ url: "/items/props/values/list", method: "get", params: data });
}
export function product_attribute_content_save(data) {
    return request({ url: "/items/props/values/save", method: "post", data });
}
export function product_attribute_content_del(data) {
    return request({ url: "/items/props/values/remove", method: "post", data });
}
export function product_type_disable(data) {
    return request({ url: "/items/category/disable", method: "post", data });
}
export function product_select(data) {
    return request({ url: "/items/options", method: "get", params: data });
}
export function product_type_select(data) {
    return request({ url: "/items/category/options", method: "get", params: data });
}
export function product_attribute_select(data) {
    return request({ url: "/items/props/options", method: "get", params: data });
}
export function product_relation_list(data) {
    return request({ url: "/items/links", method: "get", params: data });
}
export function batch_list(data) {
    return request({ url: "/series/list", method: "get", params: data });
}
export function batch_delete(data) {
    return request({ url: "/series/remove", method: "post", data });
}
export function batch_info(data) {
    return request({ url: "/series/detail", method: "post", data });
}
export function batch_save(data) {
    return request({ url: "/series/save", method: "post", data });
}
export function batch_change(data) {
    return request({ url: "/series/audio", method: "post", data });
}
export function batch_change_template(data) {
    return request({ url: "/series/template", method: "post", data });
}
export function batch_attr_list(data) {
    return request({ url: "/series/attrs", method: "post", data });
}
export function batch_add_attribute(data) {
    return request({ url: "/series/attr/attach", method: "post", data });
}
export function batch_reports(data) {
    return request({ url: "/series/report", method: "post", data });
}
export function batch_select(data) {
    return request({ url: "/series/options", method: "get", params: data });
}

// Code
export function qrcode_count_list(data) {
    return request({ url: "/code/batch/list", method: "get", params: data });
}
export function qrcode_list(data) {
    return request({ url: "/code/list", method: "get", params: data });
}
export function qrcode_info(data) {
    return request({ url: "/code/detail", method: "get", params: data });
}
export function qrcode_edit(data) {
    return request({ url: "/code/edit", method: "post", data });
}
export function qrcode_delete(data) {
    return request({ url: "/code/remove", method: "post", data });
}
export function qrcode_batch_edit(data) {
    return request({ url: "/code/batch/update", method: "post", data });
}
export function qrcode_filter(data) {
    return request({ url: "/code/filter", method: "get", params: data });
}
export function qrcode_count_create(data) {
    return request({ url: "/code/batch/create", method: "post", data });
}
export function qrcode_count_delete(data) {
    return request({ url: "/code/batch/remove", method: "post", data });
}
export function qrcode_count_refresh(data) {
    return request({ url: "/code/batch/refresh", method: "post", data });
}
export function qrcode_count_edit(data) {
    return request({ url: "/code/batch/edit", method: "post", data });
}
export function qrcode_count_info(data) {
    return request({ url: "/code/batch/detail", method: "get", params: data });
}

// Output
export function export_list(data) {
    return request({ url: "/output/list", method: "get", params: data });
}
export function export_qrcode(data) {
    return request({ url: "/output/code", method: "post", data });
}

// Shop
export function store_list(data) {
    return request({ url: "/shop/list", method: "get", params: data });
}
export function store_save(data) {
    return request({ url: "/shop/save", method: "post", data });
}
export function store_status(data) {
    return request({ url: "/shop/status", method: "post", data });
}
export function store_delete(data) {
    return request({ url: "/shop/remove", method: "post", data });
}
export function store_type_list(data) {
    return request({ url: "/shop/type/list", method: "get", params: data });
}
export function store_type_save(data) {
    return request({ url: "/shop/type/save", method: "post", data });
}
export function store_type_delete(data) {
    return request({ url: "/shop/type/remove", method: "post", data });
}
export function store_select(data) {
    return request({ url: "/shop/options", method: "get", params: data });
}
export function store_type_select(data) {
    return request({ url: "/shop/type/options", method: "get", params: data });
}
export function store_export(data) {
    return request({ url: "/shop/export", method: "get", params: data });
}

// Partner
export function agent_list(data) {
    return request({ url: "/partner/list", method: "get", params: data });
}
export function agent_save(data) {
    return request({ url: "/partner/save", method: "post", data });
}
export function agent_delete(data) {
    return request({ url: "/partner/remove", method: "post", data });
}
export function agent_number(data) {
    return request({ url: "/partner/code", method: "get", params: data });
}
export function agent_status(data) {
    return request({ url: "/partner/status", method: "post", data });
}
export function agent_level_list(data) {
    return request({ url: "/partner/tier/list", method: "get", params: data });
}
export function agent_level_save(data) {
    return request({ url: "/partner/tier/save", method: "post", data });
}
export function agent_level_delete(data) {
    return request({ url: "/partner/tier/remove", method: "post", data });
}
export function agent_select(data) {
    return request({ url: "/partner/options", method: "get", params: data });
}
export function agent_level_select(data) {
    return request({ url: "/partner/tier/options", method: "get", params: data });
}
export function agent_export(data) {
    return request({ url: "/partner/export", method: "get", params: data });
}

// Common
export function other_citys(data) {
    return request({ url: "/common/region", method: "get", params: data });
}
export function other_industry_list(data) {
    return request({ url: "/common/industry", method: "get", params: data });
}
export function other_special_import(data) {
    return request({ url: "/common/import", method: "get", params: data });
}

// Trace
export function example_list(data) {
    return request({ url: "/trace/list", method: "get", params: data });
}
export function example_save(data) {
    return request({ url: "/trace/save", method: "post", data });
}
export function example_delete(data) {
    return request({ url: "/trace/remove", method: "post", data });
}
export function example_module_list(data) {
    return request({ url: "/trace/block/list", method: "get", params: data });
}
export function example_module_delete(data) {
    return request({ url: "/trace/block/remove", method: "post", data });
}
export function example_module_sort(data) {
    return request({ url: "/trace/block/order", method: "post", data });
}
export function example_node_list(data) {
    return request({ url: "/trace/node/list", method: "get", params: data });
}
export function example_node_save(data) {
    return request({ url: "/trace/node/save", method: "post", data });
}
export function example_node_info(data) {
    return request({ url: "/trace/node/detail", method: "get", params: data });
}
export function example_node_delete(data) {
    return request({ url: "/trace/node/remove", method: "post", data });
}
export function example_node_sort(data) {
    return request({ url: "/trace/node/order", method: "get", params: data });
}
export function example_product_list(data) {
    return request({ url: "/trace/items/list", method: "get", params: data });
}
export function example_batch_list(data) {
    return request({ url: "/trace/series/list", method: "get", params: data });
}
export function example_product_save(data) {
    return request({ url: "/trace/items/save", method: "post", data });
}
export function example_batch_save(data) {
    return request({ url: "/trace/series/save", method: "post", data });
}
export function example_product_delete(data) {
    return request({ url: "/trace/items/remove", method: "post", data });
}
export function example_batch_delete(data) {
    return request({ url: "/trace/series/remove", method: "post", data });
}

// Config
export function system_company_index(data) {
    return request({ url: "/config/company/index", method: "get", params: data });
}
export function system_company_save(data) {
    return request({ url: "/config/company/save", method: "post", data });
}
export function system_security_index(data) {
    return request({ url: "/config/security/index", method: "get", params: data });
}
export function system_security_save(data) {
    return request({ url: "/config/security/save", method: "post", data });
}
export function system_wx_index(data) {
    return request({ url: "/config/wechat/index", method: "get", params: data });
}
export function system_wx_save(data) {
    return request({ url: "/config/wechat/save", method: "post", data });
}

// Activity
export function assembly_wxpacket_list(data) {
    return request({ url: "/activity/redpacket/list", method: "get", params: data });
}
export function assembly_wxpacket_status(data) {
    return request({ url: "/activity/redpacket/status", method: "post", data });
}
export function assembly_wxpacket_delete(data) {
    return request({ url: "/activity/redpacket/remove", method: "post", data });
}
export function assembly_wxpacket_info(data) {
    return request({ url: "/activity/redpacket/detail", method: "get", params: data });
}
export function assembly_wxpacket_save(data) {
    return request({ url: "/activity/redpacket/save", method: "post", data });
}
export function assembly_turntable_list(data) {
    return request({ url: "/activity/wheel/list", method: "get", params: data });
}
export function assembly_turntable_save(data) {
    return request({ url: "/activity/wheel/save", method: "post", data });
}
export function assembly_turntable_delete(data) {
    return request({ url: "/activity/wheel/remove", method: "post", data });
}
export function assembly_turntable_info(data) {
    return request({ url: "/activity/wheel/detail", method: "get", params: data });
}
export function assembly_turntable_status(data) {
    return request({ url: "/activity/wheel/status", method: "post", data });
}
export function assembly_turntable_prize(data) {
    return request({ url: "/activity/wheel/participants", method: "get", params: data });
}
export function assembly_turntable_contract(data) {
    return request({ url: "/activity/wheel/contact", method: "post", data });
}
export function assembly_turntable_examine(data) {
    return request({ url: "/activity/wheel/approve", method: "post", data });
}
export function assembly_turntable_refresh(data) {
    return request({ url: "/activity/wheel/resend", method: "post", data });
}
export function assembly_wxpacket_prize(data) {
    return request({ url: "/activity/redpacket/participants", method: "get", params: data });
}
export function assembly_wxpacket_refresh(data) {
    return request({ url: "/activity/redpacket/resend", method: "post", data });
}

// Container
export function packing_export_list(data) {
    return request({ url: "/container/export/list", method: "get", params: data });
}
export function packing_count_create(data) {
    return request({ url: "/container/batch/create", method: "post", data });
}
export function packing_export_qrcode(data) {
    return request({ url: "/container/export/code", method: "post", data });
}
export function packing_count_list(data) {
    return request({ url: "/container/batch/list", method: "get", params: data });
}
export function packing_list(data) {
    return request({ url: "/container/list", method: "get", params: data });
}
export function packing_small_list(data) {
    return request({ url: "/container/small/list", method: "get", params: data });
}
export function packing_small_product(data) {
    return request({ url: "/container/small/items", method: "get", params: data });
}
export function packing_small_delete(data) {
    return request({ url: "/container/small/remove", method: "post", data });
}
export function packing_small_tostart(data) {
    return request({ url: "/container/small/pack", method: "post", data });
}
export function packing_count_round(data) {
    return request({ url: "/container/batch/random", method: "get", params: data });
}
export function packing_unpack(data) {
    return request({ url: "/container/unpack", method: "post", data });
}
export function packing_big_list(data) {
    return request({ url: "/container/big/list", method: "get", params: data });
}
export function packing_big_tostart(data) {
    return request({ url: "/container/big/pack", method: "post", data });
}
export function packing_big_small(data) {
    return request({ url: "/container/big/small", method: "get", params: data });
}
export function packing_big_product(data) {
    return request({ url: "/container/big/items", method: "get", params: data });
}
export function packing_log_list(data) {
    return request({ url: "/container/log/list", method: "post", data });
}
export function packing_intelligence_lis(data) {
    return request({ url: "/container/smart/records", method: "get", params: data });
}
export function packing_count_select(data) {
    return request({ url: "/container/batch/options", method: "get", params: data });
}
export function packing_filter(data) {
    return request({ url: "/container/linked", method: "get", params: data });
}

// Stock
export function warehouse_list(data) {
    return request({ url: "/stock/list", method: "get", params: data });
}
export function warehouse_save(data) {
    return request({ url: "/stock/save", method: "post", data });
}
export function warehouse_delete(data) {
    return request({ url: "/stock/remove", method: "post", data });
}
export function warehouse_transfer(data) {
    return request({ url: "/stock/transfer", method: "post", data });
}
export function warehouse_search(data) {
    return request({ url: "/stock/query", method: "post", data });
}
export function warehouse_log(data) {
    return request({ url: "/stock/log", method: "post", data });
}
export function warehouse_refresh(data) {
    return request({ url: "/stock/retry", method: "post", data });
}
export function warehouse_headquarters_list(data) {
    return request({ url: "/stock/hq/list", method: "get", params: data });
}
export function warehouse_headquarters_product(data) {
    return request({ url: "/stock/hq/codes", method: "get", params: data });
}
export function warehouse_agent_list(data) {
    return request({ url: "/stock/partner/list", method: "get", params: data });
}
export function warehouse_agent_qrcode(data) {
    return request({ url: "/stock/partner/codes", method: "get", params: data });
}
export function warehouse_store_list(data) {
    return request({ url: "/stock/shop/list", method: "get", params: data });
}
export function warehouse_store_qrcode(data) {
    return request({ url: "/stock/shop/codes", method: "get", params: data });
}
export function warehouse_all_qrcode(data) {
    return request({ url: "/stock/all/codes", method: "get", params: data });
}
export function warehouse_select(data) {
    return request({ url: "/stock/options", method: "get", params: data });
}

// Transit
export function incoming_coming(data) {
    return request({ url: "/transit/process", method: "post", data });
}
export function incoming_list(data) {
    return request({ url: "/transit/list", method: "get", params: data });
}
export function incoming_delete(data) {
    return request({ url: "/transit/remove", method: "get", data });
}
export function incoming_info(data) {
    return request({ url: "/transit/detail", method: "get", params: data });
}
export function incoming_back(data) {
    return request({ url: "/transit/return", method: "post", data });
}
export function incoming_qrcode_all(data) {
    return request({ url: "/transit/codes", method: "get", params: data });
}
export function incoming_enter(data) {
    return request({ url: "/transit/shipment/add", method: "post", data });
}
export function incoming_logistics(data) {
    return request({ url: "/transit/shipment", method: "get", params: data });
}
export function incoming_logistics_del(data) {
    return request({ url: "/transit/shipment/remove", method: "post", data });
}
export function incoming_select(data) {
    return request({ url: "/transit/courier/options", method: "post", data });
}

// Profile
export function account_list(data) {
    return request({ url: "/profile/list", method: "get", params: data });
}
export function account_save(data) {
    return request({ url: "/profile/save", method: "post", data });
}
export function account_status(data) {
    return request({ url: "/profile/status", method: "post", data });
}
export function account_delete(data) {
    return request({ url: "/profile/remove", method: "post", data });
}
export function account_roles_list(data) {
    return request({ url: "/profile/roles/list", method: "get", params: data });
}
export function account_roles_create(data) {
    return request({ url: "/profile/roles/create", method: "post", data });
}
export function account_roles_info(data) {
    return request({ url: "/profile/roles/detail", method: "get", params: data });
}
export function account_roles_menus(data) {
    return request({ url: "/profile/roles/menus", method: "get", params: data });
}
export function account_roles_delete(data) {
    return request({ url: "/profile/roles/remove", method: "post", data });
}
export function account_modify_info(data) {
    return request({ url: "/profile/update", method: "post", data });
}
export function account_version(data) {
    return request({ url: "/profile/edition", method: "get", params: data });
}
export function account_v_m(data) {
    return request({ url: "/profile/nav", method: "get", params: data });
}
export function account_roles_select(data) {
    return request({ url: "/profile/roles/options", method: "get", params: data });
}
export function account_store_select(data) {
    return request({ url: "/profile/shop/options", method: "get", params: data });
}
export function account_info(data) {
    return request({ url: "/profile/config", method: "get", params: data });
}
export function account_store_review(data) {
    return request({ url: "/profile/review", method: "post", data });
}
export function account_relation_agent(data) {
    return request({ url: "/profile/links/partner", method: "post", data });
}
export function account_relation_store(data) {
    return request({ url: "/profile/links/shop", method: "post", data });
}
export function account_relation_product(data) {
    return request({ url: "/profile/links/items", method: "post", data });
}

// Record
export function version_index(data) {
    return request({ url: "/record/edition/list", method: "get", params: data });
}
export function action_index(data) {
    return request({ url: "/record/action/list", method: "get", params: data });
}

// Edition
export function version(data) {
    return request({ url: "/edition", method: "get", params: data });
}
export function version_buy(data) {
    return request({ url: "/edition/purchase", method: "post", data });
}
export function version_query(data) {
    return request({ url: "/edition/query", method: "post", data });
}
export function version_order(data) {
    return request({ url: "/edition/orders", method: "get", params: data });
}
export function version_compare(data) {
    return request({ url: "/edition/compare", method: "get", params: data });
}
export function version_qrcode(data) {
    return request({ url: "/edition/code", method: "get", params: data });
}
export function version_qrcode_buy(data) {
    return request({ url: "/edition/code/purchase", method: "post", data });
}

// Plugin
export function apps_list(data) {
    return request({ url: "/plugin", method: "get", params: data });
}
export function apps_info(data) {
    return request({ url: "/plugin/detail", method: "get", params: data });
}
export function apps_buy(data) {
    return request({ url: "/plugin/purchase", method: "post", data });
}

// Content
export function article_info(data) {
    return request({ url: "/content/detail", method: "get", params: data });
}
export function article_status(data) {
    return request({ url: "/content/status", method: "post", data });
}
export function article_sort(data) {
    return request({ url: "/content/order", method: "get", params: data });
}
export function article_save(data) {
    return request({ url: "/content/save", method: "post", data });
}
export function article_delete(data) {
    return request({ url: "/content/remove", method: "post", data });
}
export function article_list(data) {
    return request({ url: "/content/list", method: "get", params: data });
}

// Client
export function customer(data) {
    return request({ url: "/client", method: "get", params: data });
}
export function customer_save(data) {
    return request({ url: "/client/save", method: "post", data });
}
export function customer_del(data) {
    return request({ url: "/client/remove", method: "post", data });
}
export function customer_sales(data) {
    return request({ url: "/client/service", method: "get", params: data });
}
export function customer_sales_save(data) {
    return request({ url: "/client/service/save", method: "post", data });
}
export function customer_sales_info(data) {
    return request({ url: "/client/service/detail", method: "get", params: data });
}

// Block
export function module_list(data) {
    return request({ url: "/block", method: "get", params: data });
}
export function module_save(data) {
    return request({ url: "/block/save", method: "post", data });
}
export function module_del(data) {
    return request({ url: "/block/remove", method: "post", data });
}
export function module_select(data) {
    return request({ url: "/block/options", method: "get", params: data });
}
export function module_node_select(data) {
    return request({ url: "/block/node/options", method: "get", params: data });
}
export function module_node_del(data) {
    return request({ url: "/block/node/remove", method: "post", data });
}
export function module_node(data) {
    return request({ url: "/block/node", method: "get", params: data });
}
export function module_node_save(data) {
    return request({ url: "/block/node/save", method: "post", data });
}


export function get_options(data) {
    return request({ url: "/options/", method: "get", params: data });
}
